<card class="mb-0">
  <mat-form-field>
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
  </mat-form-field>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortStart="desc">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <ng-container matColumnDef="userId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> User ID </th>
      <td mat-cell *matCellDef="let element">{{element.userId}}
    </ng-container>
    <ng-container matColumnDef="analyteName">
      <th mat-header-cell *matHeaderCellDef> Analyte Name </th>
      <td mat-cell  *matCellDef="let element"><a [routerLink]="[getUrl(element.analysisType), element.analysisId, element.userId]">{{element.analyteNames}} </a></td>
    </ng-container>

    <ng-container matColumnDef="analysisDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Analysis Date </th>
      <td mat-cell *matCellDef="let element"> {{element.analysisDate}}</td>
    </ng-container>

    <ng-container matColumnDef="projectNames">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Project </th>
      <td mat-cell *matCellDef="let element">{{element.projectNames}}
    </ng-container>
    <ng-container matColumnDef="analysisType">
      <th mat-header-cell *matHeaderCellDef> Analysis Type </th>
      <td mat-cell *matCellDef="let element"> {{element.analysisTypeDisplay}} </td>
    </ng-container>
    <ng-container matColumnDef="analysisSubtype">
      <th mat-header-cell *matHeaderCellDef> Analysis Sub-Type </th>
      <td mat-cell *matCellDef="let element"> {{element.analysisSubtypeDisplay}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[ 10, 20]" showFirstLastButtons></mat-paginator>
</card>



